export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/bafcb97f65150dd63b7cabadb0e0f790.svg";